/**
 * Application Header
 * @author PBirudukota
 */
import {Component, OnInit} from '@angular/core';
import {MessagesService} from '../../services/messages.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  currentCountry: string;

  constructor(private messagesService: MessagesService) {
    this.messagesService.getLogoMessage().subscribe(message => {
      this.currentCountry = message.text;
    });
  }

  ngOnInit() {
  }

}
